import { GradeAndSectionReportUIProvider } from "./GradeAndSectionReportUIContext";
import { GradeAndSectionReportCard } from "./GradeAndSectionReportCard";

export function GradeAndSectionReportPage() {
  return (
    <GradeAndSectionReportUIProvider>
      <GradeAndSectionReportCard />
    </GradeAndSectionReportUIProvider>
 );
}